import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const getCoAList = async () => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoAList",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const testingData = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "treasury",
      pid: "chartText",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCoAListSubTypes = async (accttype) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoAListSubTypes",
      dat: {
        accttype: accttype,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCoASubtypes = async (accttype, subtype) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoASubtypes",
      dat: {
        accttype: accttype,
        subtype: subtype,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCoAAll = async (accttype, subtype) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoAAll",
      dat: {
        accttype: accttype,
        subtype: subtype,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCoAAllWatched = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoAAllWatched",
      dat: {
        param: param,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getCoAStructure = async (accttype, subtype, currCode) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "getCoAStructure",
      dat: {
        accttype: accttype,
        subtype: subtype,
        currCode: currCode,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListTransactionHistory = async (
  accountid,
  currencycode,
  startdate,
  enddate
) => {
  let startingDate;
  let endingDate;

  // if (startdate == null || enddate == null) {
  //   let today = new Date();
  //   endingDate = today.toISOString().split("T")[0];
  //   let thirtyDaysAgo = new Date();
  //   thirtyDaysAgo.setDate(today.getDate() - 30);
  //   startingDate = thirtyDaysAgo.toISOString().split("T")[0];
  // } else {
  //   startingDate = startdate;
  //   endingDate = enddate;
  // }

  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "ListTransactionHistory",
      dat: {
        accountid: accountid,
        currencycode: currencycode,
        startdate: "2023-02-12",
        enddate: "2024-03-13",
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PostAdjustment = async (
  userid,
  debitacct,
  debitvalue,
  creditacct,
  creditvalue,
  currcode,
  reason,
  externalrefid
) => {
  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "PostAdjustment",
      dat: {
        userid: userid,
        debitacct: debitacct,
        debitvalue: debitvalue,
        creditacct: creditacct,
        crebitvalue: creditvalue,
        currency: currcode,
        reason: reason,
        externalrefid: externalrefid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
